import { useApiQuery } from '../useApiQuery';
import { apiGet, operationsClient } from '@/lib/api';
import { consentEndpoints } from '@/lib/api/endpoints';
import { consentKeys } from '@/lib/queryKeys';
import type { ConsentRecord } from '@/types/paymentSchedule';

export function useConsentRecords(
  contactId: string | undefined,
  options: { activeOnly?: boolean } = {},
) {
  const activeOnly = options.activeOnly ?? false;
  return useApiQuery<ConsentRecord[]>({
    queryKey: consentKeys.byContact(contactId ?? 'none', activeOnly),
    enabled: Boolean(contactId),
    queryFn: ({ signal }) =>
      apiGet<ConsentRecord[]>(operationsClient, consentEndpoints.listForContact(contactId!), {
        signal,
        params: activeOnly ? { activeOnly: 'true' } : undefined,
      }),
  });
}
